import { Controller } from "@hotwired/stimulus"
import { formatNumber } from "../helpers"

// Licznik i suma netto zaznaczonych partnerow w modalu rozliczenia zbiorczego
export default class extends Controller {
  static targets = ["row", "selectAll", "count", "net", "submit", "submitCount"]
  static values = { locale: String, unit: String }

  connect() {
    this.update()
  }

  update() {
    const selected = this.rowTargets.filter(row => row.checked)
    const net = selected.reduce((sum, row) => sum + (parseFloat(row.dataset.net) || 0), 0)

    this.countTarget.textContent = selected.length
    this.netTarget.textContent = `${formatNumber(net, { locale: this.localeValue, app_digits: 2 })} ${this.unitValue}`
    this.submitCountTarget.textContent = selected.length
    this.submitTarget.disabled = selected.length === 0

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = this.selectableRows().length > 0 && selected.length === this.selectableRows().length
    }
  }

  toggleAll(event) {
    this.selectableRows().forEach(row => {
      row.checked = event.currentTarget.checked
    })

    this.update()
  }

  // wiersze zablokowane serwerowo (brak danych do faktury, brak stawki) nie dają się zaznaczyć
  selectableRows() {
    return this.rowTargets.filter(row => !row.disabled)
  }
}
